import type { CartItemForClient } from "@/lib/shared/types/interfaces";

/** Keep only lines backed by a published product (matches checkout / payment validation). */
export function filterPurchasableCartItems(items: CartItemForClient[]): CartItemForClient[] {
  return items.filter((item) => item.product.status === "published");
}
